import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectors } from 'store';

export interface ExampleBannerHook {
  visible: boolean;
}

export default function useExampleBanner(): ExampleBannerHook {
  const id = useSelector(selectors.document.getId);
  const introductions = useSelector(selectors.introduction.getEntities);
  const location = useLocation();

  const visible = useMemo(() => {
    if (!id) return false;
    const introduction = introductions?.[id];
    const example = introduction?.flow_type === 'example';
    if (!introduction || !example) return false;
    if (location.pathname.includes('apply')) return true;
    if (location.pathname.includes('create-job')) return true;
    if (location.pathname.includes('introduction')) return true;
    if (location.pathname.includes('job')) return true;
    if (location.pathname.includes('trader')) return true;
    return false;
  }, [introductions, id, location]);

  return {
    visible,
  };
}
